import request from '@/utils/request'
import environment from '@/utils/environment'

export function userLogin(data) {
  localStorage.setItem('token', 'token')
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'post'
  })
}
export function logout() {
  return request({
    url: '/admin/out',
    method: 'post'
  })
}

export function captcha(time) {
  var api = environment.verification()
  return `${api}?t=${time}`
}

// 谷歌key
export function googleKey() {
  return request({
    url: '/common/googleKey',
    method: 'post'
  })
}
